import qs from 'qs';
import axios from 'axios';
import {
	isInvalid,
	isFunction,
	isObject,
	formatterDomainApi,
	getFormDataByJson,
	isString,
} from '@hst/utils';
import { isProd } from 'src/config/env';

const service = axios.create({
	timeout: 10000,
	retry: 1, // 重连次数
	retryDelay: 2000, // 重连间隔
	withCredentials: true, // 是否跨域携带 cookie
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
});

// 添加请求拦截器

service.interceptors.request.use(
	(config) => {
		// 网关配置
		const url = config.url;
		const gateway = '/api';
		if (url && url.indexOf('//') < 0 && !url.match(gateway)) {
			config.url = gateway + url;
		}
		// 接口重写
		if (isProd) {
			// 设置接口的域名
			const apiDomain = config.apiDomain;
			let origin = '';
			if (isFunction(apiDomain)) {
				// 方式一：函数认为是获取域名地址的方法 使用返回接口作为域名
				origin = apiDomain.call(config);
			} else if (isObject(apiDomain)) {
				// 方式二：对象认为是 formatterDomainApi 方法的参数
				origin = formatterDomainApi(apiDomain);
			} else if (isString(apiDomain)) {
				// 方式三：常用的方式
				origin = apiDomain;
			}
			config.url = origin + url;
		}
		// 用完自定义属性 移除属性
		delete config.apiDomain;
		// 表单提交
		if (config.form) {
			if (isInvalid(config.data)) {
				for (const key in config.data) {
					if (Array.isArray(config.data[key])) {
						config.data[key] = JSON.stringify(config.data[key]);
					}
				}
			}
			config.data = qs.stringify(config.data);
			config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
		}
		// 文件上传
		if (config.file) {
			config.data = getFormDataByJson(config.data); // 对象转 Formdata
			config.headers['Content-Type'] = 'multipart/form-data;charset=UTF-8';
		}

		return config;
	},
	(error) => {
		// 请求错误拦截
		return Promise.reject(error);
	},
);

service.interceptors.response.use(
	function (response) {
		return response.data;
	},
	function (error) {
		return Promise.reject(error);
	},
);

export default service;
